import { Action, Reducer } from 'redux';
import {
  EntityTypeActionTypes,
  EntityTypeState,
  EntityTypeTypes
} from './entityTypeTypes';

export const INITIAL_STATE: EntityTypeState = {
  entityType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const entityTypeReducer: Reducer<EntityTypeState> = (
  state: EntityTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as EntityTypeActionTypes;
  switch (actionTypes.type) {
    case EntityTypeTypes.GET_ENTITY_TYPE:
      return {
        ...state,
        entityType: { ...state.entityType, isLoading: true }
      };
    case EntityTypeTypes.SAVE_ENTITY_TYPE:
      return {
        ...state,
        entityType: {
          ...state.entityType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case EntityTypeTypes.RESET_REDUCER_ENTITY_TYPE:
      return {
        ...state,
        entityType: INITIAL_STATE.entityType
      };
    default:
      return state;
  }
};

export default entityTypeReducer;
